import { render, staticRenderFns } from "./designationList.vue?vue&type=template&id=2db9884a&"
import script from "./designationList.vue?vue&type=script&lang=js&"
export * from "./designationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports